import { render, staticRenderFns } from "./ActaCopasst.vue?vue&type=template&id=9f465004&"
import script from "./ActaCopasst.vue?vue&type=script&lang=js&"
export * from "./ActaCopasst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports